/**
 * Base Unit
 */
export const BaseUnit = 16;
